import { Button, Dialog, DialogContent, DialogTitle, Icon, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { Space } from 'v2/components/Shared/Space';
import useGetUser from 'v2/hooks/useGetUser';

import { Form } from './Form';
import { MyEduzzIcon } from './MyeduzzIcon';
import useStyles from './styles';

import type IProduct from 'interfaces/IProduct';

type ModalProps = {
  open: boolean;
  handleClose: () => void;
  product: Partial<IProduct>;
  updateProduct: (product: Partial<IProduct>) => void;
};

export const BasePlanModal = ({ open, handleClose, product, updateProduct }: ModalProps) => {
  const user = useGetUser();
  const isUnity = user?.is_clube_black;
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));

  return (
    <Dialog fullScreen open={open} onClose={handleClose}>
      <DialogTitle style={{ paddingBlock: 0 }}>
        <div className={classes.container}>
          <div className={classes.leftContainer}>
            <MyEduzzIcon />
            {!isMobile && <Typography variant='h6'>MyEduzz</Typography>}
            <div className={classes.title}>
              {isUnity && !isMobile && (
                <Typography className={classes.unity} paragraph>
                  UNITY
                </Typography>
              )}
              {!isUnity && !isMobile && (
                <Typography className={classes.pro} paragraph>
                  PRO
                </Typography>
              )}
              <Typography paragraph>Criar plano de assinaturas</Typography>
            </div>
          </div>
          <Button id='base-plan-close-modal' endIcon={<Icon>close</Icon>} onClick={handleClose}>
            {!isMobile && 'Fechar'}
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className={classes.formContainer}>
          <h1>Cadastro de plano de assinaturas</h1>
          <p>Os dados abaixo são muito importantes para seu plano. Preencha-os com atenção.</p>
          <Space size={24} axis='vertical' />
          <Form product={product} handleClose={handleClose} updateProduct={updateProduct} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
